import Cookies from 'js-cookie';
import toast from "react-hot-toast";
import { axiosInstance } from '../lib/axios';

const loginapi = async (email, password) => {
    try {
        const res = await axiosInstance.post(
            `/users/login`,
            { email, password }
        );

        toast.success("Successfully Login");
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};


const checkAuthapi = async () => {
    try {
        const token = Cookies.get("accessToken");
        const res = await axiosInstance.get(
            `/users/profile`,
            {
                headers: { Authorization: `Bearer ${token}` },
            }
        );
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message);
        // toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

const getAllUserFunctionApi = async (pageNumber, pageSize, search, field) => {
    try {

        const params = new URLSearchParams();
        params.append('field', field);
        params.append('search', search);
        params.append('pageSize', pageSize);
        params.append('pageNumber', pageNumber);

        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.get(`/users/getuser?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        // toast.success("Successfully fetched!");
        return res.data.data
        // console.log("lorem")

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

const registeruser = async (form) => {
    try {
        const {
            fullName, username, password, confirmPassword, email, avatar, address, role
        } = form;

        if (password !== confirmPassword) {
            toast.error("password and confirm password are not same");
            console.log(password, confirmPassword)
            return
        }
        const formData = new FormData();

        formData.append("fullName", fullName);
        formData.append("username", username);
        formData.append("password", password);
        formData.append("avatar", avatar);
        formData.append("email", email);
        formData.append("address", JSON.stringify(address));
        formData.append("role", role);

        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.post(
            `/users/admin`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        // console.log("category", res)
        toast.success("Successfully Registered!");
        return res.data?.data;

    } catch (err) {
        console.error(err);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
    console.log(form)
};

const deleteuser = async (id) => {
    try {

        if (!id) {
            toast.error("id is not present");
            return
        }
        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.delete(`/users/${id}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        toast.success("Successfully deleted!");
        // return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

const dowloaduserslist = async (pageNumber, pageSize, search, field) => {
    try {

        const params = new URLSearchParams();
        params.append('field', field);
        params.append('search', search);
        params.append('pageSize', pageSize);
        params.append('pageNumber', pageNumber);

        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.get(`/users/dowload?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
            responseType: "arraybuffer",
        })

        const blob = new Blob([res.data], { type: "application/pdf" });


        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);

        const now = new Date();
        const timeString = `${now.getHours()}_${now.getMinutes()}_${now.getSeconds()}`;
        link.download = `users-details_${timeString}.pdf`;


        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Clean up
        window.URL.revokeObjectURL(link.href);

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

const resetpassword = async (form) => {
    try {

        const { oldPassword, newPassword } = form
        const accessToken = Cookies.get("accessToken");

        const res = await axiosInstance.post(
            `/users/resetpassword`,
            {
                oldPassword, newPassword
            }
            ,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "application/json",
                },
            }
        );

        // console.log("category", res)
        toast.success("Successfully Registered!");
        return res.data?.data;

    } catch (err) {
        console.error(err);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

export {
    loginapi,
    checkAuthapi,
    registeruser,
    deleteuser,
    resetpassword,
    dowloaduserslist,
    getAllUserFunctionApi
}
